module.exports = __webpack_public_path__ + "ec248ccf368ee67024baf717ab378bdf.pdf";